<script setup>
import { computed,defineProps } from 'vue';
import { useStore } from 'vuex'
import axios from 'axios';
import { authHeader } from '@/helpers/authservice/auth-header';
import Swal from 'sweetalert2';

const store = useStore()
const loading = computed(() => store.state.globals.loading);
const traffic_record = computed(() => store.state.trafficRecordComponent.traffic_record);
const reloadTrafficRecord = async () => await store.dispatch('trafficRecordComponent/reloadTrafficRecord');

const props = defineProps({
  refresh_btn: {
    type: Boolean,
    default: false,
  }
});

const refreshNov = async () => {
  try {
    store.dispatch('globals/loading', null, { root: true });

    await axios.get(`/traffic_record_component/nov/generate/${traffic_record.value.id}`,{
        headers: authHeader()
    });

    await reloadTrafficRecord();

    store.dispatch('globals/loaded', null, { root: true });
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: error,
    })
    store.dispatch('globals/loaded', null, { root: true });
  }
}

</script>

<template>
    <div class="col-12 mb-1">
      <b-overlay :show="loading">
        <div class="card">
          <div class="card-body overflow-auto">
            <div style="text-align: right;">
              <button v-if="props.refresh_btn" type="button" class="btn btn-default mb-2" @click="refreshNov">Refresh NOV</button>
            </div>
            <iframe v-if="traffic_record.violation_penalties.length && traffic_record.violation_penalties[0].generated_pdf_file_link" :src="traffic_record.violation_penalties[0].generated_pdf_file_link" height="800px" width="100%"></iframe>
          </div>
        </div>
      </b-overlay>
    </div>
</template>
